import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import Button from '../../../../Button';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import s from './ActionBarB18Link.scss';
/**
 * Renders a view 'b18' Button. Also provides some ActionBar item styling.
 *
 * @deprecated We're moving away from the Button component
 */
var ActionBarB18Link = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return (React.createElement(Button, __assign({ view: "b18", className: c(s['root'], className) }, rest),
        React.createElement(ActionBarItemContentWrapper, null, children)));
};
ActionBarB18Link.displayName = 'ActionBarB18Link';
export default ActionBarB18Link;
//# sourceMappingURL=ActionBarB18Link.js.map